import { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import DealerDashboard from './components/DealerDashboard';
import { authAPI, removeToken } from './api';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  // Проверка аутентификации при загрузке
  useEffect(() => {
    checkAuthentication();
  }, []);

  const checkAuthentication = async () => {
    try {
      const response = await authAPI.checkAuth();
      if (response.data.authenticated) {
        setIsAuthenticated(true);
        setUser(response.data.user);
        console.log('✅ JWT token is valid');
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      removeToken();
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogin = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
    console.log('✅ User logged in with JWT');
  };

  const handleLogout = async () => {
    try {
      await authAPI.logout();
      removeToken();
      setIsAuthenticated(false);
      setUser(null);
      console.log('✅ User logged out, JWT token removed');
    } catch (error) {
      console.error('Logout failed:', error);
      // В любом случае удаляем токен и выходим
      removeToken();
      setIsAuthenticated(false);
      setUser(null);
    }
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p style={{ marginTop: '20px', color: 'white' }}>Загрузка...</p>
      </div>
    );
  }

  return (
    <div className="app">
      {isAuthenticated ? (
        // Дилер (реселлер) получает свой урезанный кабинет: только его группы и ключи
        user?.role === 'dealer'
          ? <DealerDashboard user={user} onLogout={handleLogout} />
          : <Dashboard user={user} onLogout={handleLogout} />
      ) : (
        <Login onLogin={handleLogin} />
      )}
    </div>
  );
}

export default App;

